import React, { useState, useEffect } from 'react'

import HoverTooltip from '../../../../../../components/HoverTooltip'
import MoneyInput from '../../../../../../components/form/MoneyInput'
import CurrencySelector from '../../../../../../components/currency/CurrencySelector'

import Section from '../../../../../../components/Section'
import {
    Contract,
    ContractPerformance,
    ContractChangeDoc,
    ContractDoc,
} from '../../../types'

import {
    purchaseTypeInfo,
    purchaseInfo,
    planInfo,
    ContractChangeInfoError,
} from '../types'

import { CurrencyList } from '../../../../Plans/Positions/Edit/types'

import Checkbox from '../../../../../../components/form/Checkbox'
import ContractChangeDocsTable from './ContractTable/ContractChangeDocsTable'

type Props = {
    theme: string
    contractAction: boolean
    contractGuid: string | undefined
    currencyList: CurrencyList[]
    contractPrice: number | undefined
    contractRubPrice: number | null | undefined
    contractsLoading: boolean
    contractsError: string | null
    contract: Contract
    onChangeContract: (change_contract: boolean) => void
    onModificationDescription: (modification_description: string) => void
    onApproveDate: (approve_date: string | null) => void
    onHasGoodInfo: (has_good_info: boolean | null) => void
    contractChangeDocs: ContractChangeDoc | null
    onChangeDocs: (change_docs: ContractChangeDoc | null) => void
    // onNotice44: (notice_44: boolean) => void
    // onNotice44Num: (notice_44_num: string | null) => void
    // onNotice44Lot: (lot_44_num: string | null) => void
    // onNoticeNotPlacedByFz223p5s4: (
    //     notice_not_placed_by_fz223_p5_s4: boolean
    // ) => void
    // onEmergency: (emergency: boolean) => void
    // onResumeDate: (resume_date: string | null) => void

    // onPurchaseInfo: (purchase_info: purchaseInfo) => void
    // onPlanInfo: (plan_info: planInfo) => void
    // onPurchaseTypeInfo: (purchase_type_info: purchaseTypeInfo) => void
    // onDigitalPurchase: (digital_purchase: boolean) => void
    // onProvider: (provider: boolean) => void
    // onTermination: (termination: boolean) => void
    // onExtension: (extension: boolean) => void
    // onCustomerAppealedOrNeedsApproval: (
    //     customer_appealed_or_needs_approval: boolean
    // ) => void
    // onCustomerApprovalOrAntimonopolyDescisionDate: (
    //     customer_approval_or_antimonopoly_descision_date: string | null
    // ) => void
    errors?: ContractChangeInfoError
}

const ContractChangeInfo: React.FC<Props> = (props) => {
    const [isChangeNotice44, setChangeNotice44] = useState<boolean>(false)
    const [сhangeNotice44Popup, setChangeNotice44Popup] =
        useState<boolean>(false)
    const [
        сhangeNoticeNotPlacedByFz223p5s4Popup,
        setChangeNoticeNotPlacedByFz223p5s4Popup,
    ] = useState<boolean>(false)

    const handleChangeMode = () => {
        console.log('hadmleChangeMode')
    }

    return (
        <Section title="Информация об изменении договора">
            <fieldset disabled={props.contractAction}>
                <div className="flex flex-col w-full gap-3">
                    <div className="flex flex-row w-full gap-x-5 ">
                        <div className="flex flex-col min-w-[200px]">
                            <Checkbox
                                label="Изменение договора"
                                checked={props.contract?.change_contract}
                                onChange={props.onChangeContract}
                                disabled={false}
                            />
                        </div>
                        <div className="flex flex-col min-w-[200px]">
                            <Checkbox
                                label="Исправление сведений"
                                checked={!props.contract?.change_contract}
                                onChange={() => {
                                    props.onChangeContract(
                                        !props.contract?.change_contract
                                    )
                                    props.onHasGoodInfo(null)
                                    props.onApproveDate(null)
                                    props.onChangeDocs(null)
                                }}
                                disabled={false}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col w-full items-start justify-start ">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Причина изменения информации о договоре{' '}
                            <span className="text-[#FF0000]">*</span>
                        </label>
                        <HoverTooltip
                            tooltipText={
                                props.errors?.modification_description || ''
                            }
                        >
                            <textarea
                                className={`form-textarea w-full ${
                                    props.errors?.modification_description
                                        ? 'border border-[#C15C5C]'
                                        : ''
                                }`}
                                maxLength={2000}
                                rows={3}
                                value={
                                    props.contract?.modification_description ||
                                    ''
                                }
                                onChange={(e) =>
                                    props.onModificationDescription(
                                        e.target.value
                                    )
                                }
                            />
                        </HoverTooltip>
                    </div>
                    {props.contract.change_contract && (
                        <>
                            <div className="flex flex-col">
                                <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                    Дата утверждения изменений{' '}
                                    <span className="text-[#FF0000]">*</span>
                                </label>
                                <HoverTooltip
                                    tooltipText={
                                        props.errors?.approve_date || ''
                                    }
                                >
                                    <input
                                        type="date"
                                        className={`form-input user-input-placeholder w-[200px]  ${
                                            props.errors?.approve_date
                                                ? 'border border-[#C15C5C] rounded-md p-2'
                                                : ''
                                        }`}
                                        value={
                                            props.contract?.approve_date ?? ''
                                        }
                                        onChange={(e) => {
                                            e.target.value == ''
                                                ? props.onApproveDate(null)
                                                : props.onApproveDate(
                                                      e.target.value
                                                  )
                                        }}
                                        style={{
                                            colorScheme:
                                                props.theme == 'dark'
                                                    ? 'dark'
                                                    : 'light',
                                        }}
                                    />
                                </HoverTooltip>
                            </div>
                            <div className="flex flex-row w-full gap-x-5 ">
                                <div className="flex flex-col min-w-[200px]">
                                    <Checkbox
                                        label="Изменяются сведения об объеме, цене закупаемых товаров, работ, услуг или сроках исполнения договора"
                                        checked={
                                            props.contract?.has_good_info ??
                                            false
                                        }
                                        onChange={props.onHasGoodInfo}
                                        disabled={false}
                                    />
                                </div>
                            </div>
                            {props.contract.has_good_info && (
                                <ContractChangeDocsTable
                                    theme={props.theme}
                                    contractAction={props.contractAction}
                                    contractGuid={props.contractGuid}
                                    contract={props.contract}
                                    errors={props.errors}
                                    onChangeDocs={props.onChangeDocs}
                                    contractChangeDocs={
                                        props.contractChangeDocs
                                    }
                                />
                            )}
                        </>
                    )}
                </div>
            </fieldset>
        </Section>
    )
}

export default ContractChangeInfo
